import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginBottom: '19px'
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    color: '#071B27',
    fontSize: 13,
    fontWeight: '500',
    lineHeight: '18px'
  },
  formControlLabelRoot: {
    marginRight: '24px'
  },
  checkboxRoot: {},
  checked: {
    color: '#1D9DC6'
  },
  disabledCheckbox: {
    color: '#BECEDA',
    backgroundColor: '#BECEDA'
  },
  checkboxIcon: {
    color: theme.baseUI.color,
    fontSize: '21px'
  },
  checkboxLabel: {
    display: 'flex',
    position: 'relative'
  },
  disabled: {
    color: '#BECEDA'
  }
}));
